import type { ReactNode } from 'react'

import Button from '@src/component/ButtonV2/Button'

import * as styles from './TestableAudioOutputDevice.css'

interface TestableAudioOutputDeviceProps {
  onTestClick?: () => void
  children?: ReactNode
  isTestingEnabled?: boolean
  isTestRunning?: boolean
}

function TestableAudioOutputDevice({
  onTestClick,
  children,
  isTestRunning = false,
  isTestingEnabled = true,
}: TestableAudioOutputDeviceProps) {
  if (!isTestingEnabled) {
    return <>{children}</>
  }
  return (
    <div className={styles.root}>
      {children}
      {/* eslint-disable-next-line @typescript-eslint/no-deprecated */}
      <Button
        variant="outlined"
        type="button"
        color="textPrimary"
        onClick={onTestClick}
        className={styles.button}
      >
        {isTestRunning ? 'Stop audio' : 'Test audio'}
      </Button>
    </div>
  )
}

export default TestableAudioOutputDevice
